import React from 'react';
import Modal from './../components/modals';
import _ from 'lodash';

class VendorUsersListRow extends React.Component {
	constructor(props) {
		super();
		this.state = {
			xPos: '0px',
			yPos: '0px',
			showMenu: false,
			showDiscardModal: false,
		};
		this.ref = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener('mousedown', this.handleClickOutside);
	};
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	handleClickOutside = (event) => {
		if (this.ref.current && !this.ref.current.contains(event.target)) {
			this.setState({
				showMenu: false,
			});
		}
	};
	handleContextMenu = (e) => {
		if (e) {
			e.preventDefault();

			this.setState({
				xPos: `${e.pageX}px`,
				yPos: `${e.pageY}px`,
				showMenu: true,
			});
		}
	};
	handleClick = (e) => {
		if (this.state.showMenu) this.setState({ showMenu: false });
	};
	render() {
		let user = this.props.data;
		return (
			<>
				<tr
					onClick={(e) => this.handleClick(e)}
					onContextMenu={(e) => this.handleContextMenu(e)}
					ref={this.ref}
				>
					<td className="vu-td">
						<div className="upper-text">
							{user.displayName ? user.displayName : '-'}
						</div>
						<div className="lower-text">
							{_.capitalize(user.firstName) + ' ' + _.capitalize(user.lastName)}
						</div>
					</td>
					<td className="vu-td">
						<div className="upper-text">{user.phoneNumber}</div>
						<div className="lower-text">{user.email}</div>
					</td>
					{this.state.showMenu ? (
						<div
							className="shoot-right-click-menu"
							style={{
								top: this.state.yPos,
								left: this.state.xPos,
								position: 'fixed',
							}}
						>
							<span onClick={(e) => this.setState({ showDiscardModal: true })}>
								Remove user
							</span>
						</div>
					) : (
						''
					)}
				</tr>
				<Modal
					handleClose={() => this.setState({ showDiscardModal: false })}
					show={this.state.showDiscardModal}
					modalType={'center'}
				>
					<div className="center-confirm-delete-new">
						<div className="delete-modal-header">REMOVE CUSTOM CREATED</div>
						<div className="middle-delete-container">
							<div className="middle-text">Are you sure?</div>
							<div className="middle-desc">
								If you remove this user, you cannot undo this
							</div>
						</div>
						<div className="bottom-delete-btns">
							<span
								className="cancel-btn"
								onClick={(e) => this.setState({ showDiscardModal: false })}
							>
								No, Cancel
							</span>
							<span
								className="delete-btn"
								onClick={(e) => {
									this.props.removeVendorUser(this.props.data.email);
									this.setState({ showDiscardModal: false, showMenu: false });
								}}
							>
								Yes, Remove
							</span>
						</div>
					</div>
				</Modal>
			</>
		);
	}
}

export default VendorUsersListRow;
